import React from 'react';
import './style.css';
import ProductBar from './ProductBar';
import { HashRouter, Routes, Route, Outlet, Link } from 'react-router-dom';

let history = window.location
export default function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<ProductBar history={history} />} />
      </Routes>
    </HashRouter>
  );
}
